import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { HOST, ROUTE_NAME_OPTIONS } from '../utils/constants.ts';
import toast from 'react-hot-toast';

const Verify = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasVerified = useRef(false); // Evita múltiples llamadas

  useEffect(() => {
    if (hasVerified.current) return;
    hasVerified.current = true;

    const token = searchParams.get('token');

    if (token) {
      fetch(`${HOST}/auth/verify?token=${token}`)
        .then((response) => {
          if (response.ok) {
            toast.success('Cuenta verificada exitosamente', { duration: 5000 });
            navigate(`/${ROUTE_NAME_OPTIONS.LOGIN}`);
          } else {
            throw new Error('El token es inválido o ha expirado');
          }
        })
        .catch((error) => {
          toast.error(error.message, { duration: 5000 });
          navigate(`/${ROUTE_NAME_OPTIONS.LOGIN}`);
        });
    } else {
      toast.error('Token no encontrado', { duration: 5000 });
      navigate(`/${ROUTE_NAME_OPTIONS.LOGIN}`);
    }
  }, [searchParams, navigate]);

  return <div>Verificando tu cuenta...</div>;
};

export default Verify;
